import { Slider } from "@base-ui/react/slider"
import PropTypes from "prop-types"
import React from "react"

const THUMB_CLASS = [
  "size-4 rounded-full bg-blue-700",
  "outline outline-1 outline-blue-700",
  "select-none",
  "has-[:focus-visible]:outline has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-blue-800",
].join(" ")

const BaseSlider = ({ value, onValueChange, min = 0, max = 100 }) => (
  <Slider.Root value={value} onValueChange={onValueChange} min={min} max={max}>
    <Slider.Control className="flex w-full touch-none select-none items-center py-3">
      <Slider.Track className="h-1 w-full select-none rounded bg-gray-200 shadow-[inset_0_0_0_1px] shadow-gray-200">
        <Slider.Indicator className="select-none rounded bg-blue-700" />
        <Slider.Thumb index={0} className={THUMB_CLASS} />
        <Slider.Thumb index={1} className={THUMB_CLASS} />
      </Slider.Track>
    </Slider.Control>
  </Slider.Root>
)

BaseSlider.propTypes = {
  value: PropTypes.arrayOf(PropTypes.number).isRequired,
  onValueChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
}

export default BaseSlider
